<template>
  <layout-vertical>

    <template v-slot:vertical-menu-header>
      <router-link
        to="/"
        class="brand"
        aria-label="Breeze"
      >
        <ds-breeze-logo
          :height="24"
          :label="null"
        />
      </router-link>
    </template>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import { DsBreezeLogo } from '@/design-system/components'
import Navbar from '../components/Navbar.vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
    DsBreezeLogo,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/design-system/mixins';

.brand {
  display: inline-flex;
  align-items: center;
  color: $c-orange;

  &:hover { color: darken($c-orange, 8%); }
}
</style>
